/**
 * An arbitrary namespace.
 *
 * You should use a namespace for your token storage if
 * possible so that your application does not clobber another application's.
 *
 * @see https://randomwordgenerator.com/ for more inspiration
 */

export const CUSTOM_OKTA_STORAGE_KEY = "OpsLinkOkta";

export const LOCAL_TOOLS_TOKEN_PROFILES = [
  {
    origin: "https://opslink.dev.cglcloud.in",
    issuer: "https://login-qa-customer.cargill.com/oauth2/auszzmfs36uUBqxYU0h7",
    clientId: "0oa22aved3nEX75tW0h8",
  },
  {
    origin: "https://opslink.cglcloud.com",
    issuer: "https://login.mycargill.com/oauth2/aus7560izdyHixyCz0i7",
    clientId: "0oacxsa9dueqlWFEW0i7",
  },
] as const;
